import { MigrationStatus } from '@src/constants/MigrationStatus';
import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  id: string;
  status: MigrationStatus;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/save_status/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useSaveMigrationStatus = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveMigrationStatusLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationStatus;
